// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import toast, { Toaster } from "react-hot-toast";
// import "../assets/LeaveReport.css";

// const LeaveReport = () => {
//   const [leaveData, setLeaveData] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(true);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 8;

//   // Admin ID
//   const adminId = 14;

//   // Modal state
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedLeave, setSelectedLeave] = useState(null);
//   const [adminRemark, setAdminRemark] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [employeId, setEmployeId] = useState("");
//   const [employename, setEmployeName] = useState("");

//   useEffect(() => {
//     fetchLeaves();
//   }, []);

// const fetchLeaves = async () => {

//             const superAdminId = localStorage.getItem("adminuserId"); // Read superAdminId

//   try {
//     console.log("📌 Fetching leave report...");

//     // 1️⃣ Fetch all leaves
//     const res = await axios.get(`https://payyug.in/api/get-leave?adminId=${superAdminId}`);
//     const leaves = res.data || [];

//     console.log("📥 Raw Leaves:", leaves);

//     // 2️⃣ Extract unique employeeIds (STRING values)
//     const employeeIds = [...new Set(leaves.map(l => l.employeeId))];
//     console.log("👥 Unique Employee IDs:", employeeIds);

//     let employeeMap = {};

//     // 3️⃣ Fetch employee details using STRING employeeId
//     for (let id of employeeIds) {
//       try {
//         console.log(`🔍 Fetching employee details for employeeId = ${id}`);

//         const empRes = await axios.get(
//           `https://payyug.in/api/hr-employees-filter?employeeId=${id}&superAdminId=${superAdminId}`
//         );

//         console.log(`📥 Employee API Response for ${id}:`, empRes.data);

//         // API returns: data.data.fullName
//         if (empRes.data?.data) {
//           employeeMap[id] = empRes.data.data.fullName; // string fullName
//         } else {
//           employeeMap[id] = "Unknown";
//         }

//       } catch (err) {
//         console.log(`⚠️ Error fetching details for ${id}`);
//         employeeMap[id] = "Unknown";
//       }
//     }

//     console.log("📌 Employee Name Map:", employeeMap);

//     // 4️⃣ Merge employeeName into leave data
//     const combined = leaves.map(leave => ({
//       ...leave,
//       employeeName: employeeMap[leave.employeeId] || "Unknown"
//     }));

//     console.log("📦 Final Combined Leaves:", combined);
//     setLeaveData(combined);

//     // 5️⃣ Store first employee data in state
//     if (combined.length > 0) {
//       setEmployeId(combined[0].employeeId);       // HM0100056
//       setEmployeName(combined[0].employeeName);   // Actual name
//       console.log("✅ Saved first employee:", combined[0]);
//     }

//   } catch (error) {
//     console.error("❌ Error:", error);
//     toast.error("Failed to load leave report.");
//   } finally {
//     console.log("⏳ Done fetching leaves.");
//     setLoading(false);
//   }
// };

//   const openRemarkModal = (leave, status) => {
//     setSelectedLeave(leave);
//     setSelectedStatus(status);
//     setAdminRemark("");
//     setModalOpen(true);
//   };

//   const submitStatusUpdate = async () => {
//     if (!adminRemark.trim()) {
//       return toast.error("Admin remark is required!");
//     }

//     try {
//       await axios.put(
//         `https://payyug.in/api/update-status/${selectedLeave.id}`,
//         {
//           status: selectedStatus,
//           adminId,
//           adminRemark,
//         }
//       );

//       toast.success(`Leave ${selectedStatus} successfully`);
//       setModalOpen(false);
//       fetchLeaves();
//     } catch (error) {
//       toast.error(error?.response?.data?.error || "Failed to update leave");
//     }
//   };

//   // Search filter
//   const filtered = leaveData.filter((l) =>
//     l.employeeId?.toString().includes(search)
//   );

//   // Pagination logic
//   const lastIndex = currentPage * itemsPerPage;
//   const firstIndex = lastIndex - itemsPerPage;
//   const paginatedData = filtered.slice(firstIndex, lastIndex);

//   const totalPages = Math.ceil(filtered.length / itemsPerPage);

//   const goToPage = (number) => {
//     if (number >= 1 && number <= totalPages) {
//       setCurrentPage(number);
//     }
//   };

//   return (
//     <div className="leave-report-container">
//       <Toaster position="top-right" />

//       <h2 className="leave-report-title">Employee Leave Report</h2>

//       {/* Search */}
//       <div className="leave-search-wrapper">
//         <input
//           type="text"
//           placeholder="🔍 Search by Employee ID"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="leave-search"
//         />
//       </div>

//       {/* Table */}
//       {loading ? (
//         <p className="loading">Loading leave records...</p>
//       ) : paginatedData.length === 0 ? (
//         <p className="no-data">No leave applications found</p>
//       ) : (
//         <div className="leave-table-card">
//           <table className="leave-report-table">
//             <thead>
//               <tr>
//                 <th>Employee Name</th>
//                 <th>Type</th>
//                 <th>Start</th>
//                 <th>End</th>
//                 <th>Reason</th>
//                 <th>Status</th>
//                 <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedData.map((leave) => (
//                 <tr key={leave.id}>
//                   {/* <td>{leave.employeeId}</td> */}
//                   <td>{leave.employeeName}</td>
//                   <td>{leave.leaveType}</td>
//                   <td>{leave.startDate}</td>
//                   <td>{leave.endDate}</td>
//                   <td>{leave.reason}</td>

//                   <td>{leave.status}

//                   </td>

//                   <td>
//                     <div className="action-buttons">
//                       <button
//                         className="approve-btn"
//                         onClick={() => openRemarkModal(leave, "approved")}
//                         // disabled={leave.status !== "pending"}
//                       >
//                         Approve
//                       </button>

//                       <button
//                         className="reject-btn"
//                         onClick={() => openRemarkModal(leave, "rejected")}
//                         // disabled={leave.status !== "pending"}
//                       >
//                         Reject
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination */}
//           <div className="pagination">
//             <button onClick={() => goToPage(currentPage - 1)}>Prev</button>

//             {[...Array(totalPages)].map((_, i) => (
//               <button
//                 key={i}
//                 className={currentPage === i + 1 ? "active-page" : ""}
//                 onClick={() => goToPage(i + 1)}
//               >
//                 {i + 1}
//               </button>
//             ))}

//             <button onClick={() => goToPage(currentPage + 1)}>Next</button>
//           </div>
//         </div>
//       )}

//       {/* Modal for Remark */}
//       {modalOpen && (
//         <div className="remark-modal-overlay">
//           <div className="remark-modal">
//             <h3>
//               {selectedStatus === "approved"
//                 ? "Approve Leave"
//                 : "Reject Leave"}
//             </h3>

//             <textarea
//               placeholder="Enter admin remark"
//               value={adminRemark}
//               onChange={(e) => setAdminRemark(e.target.value)}
//             ></textarea>

//             <div className="modal-buttons">
//               <button className="modal-submit" onClick={submitStatusUpdate}>
//                 Submit
//               </button>
//               <button
//                 className="modal-cancel"
//                 onClick={() => setModalOpen(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default LeaveReport;

import React, { useEffect, useState } from "react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import "../assets/LeaveReport.css";

const LeaveReport = () => {
  const [leaveData, setLeaveData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Modal
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [adminRemark, setAdminRemark] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  // Employee detail stash
  const [employeeId, setEmployeeId] = useState("");
  const [employeeName, setEmployeeName] = useState("");

  const superAdminId = localStorage.getItem("adminuserId");

  useEffect(() => {
    fetchLeaves();
  }, []);

  const fetchLeaves = async () => {
    try {
      console.log("📌 Fetching leave report...");

      // 1️⃣ Fetch leaves list
      const res = await axios.get(
        `https://payyug.in/api/get-leave?adminId=${superAdminId}`
      );

      const leaves = res.data || [];
      console.log("📥 Raw Leaves:", leaves);

      // 2️⃣ Unique string employeeIds (HM0100056 type)
      const employeeIds = [...new Set(leaves.map((l) => l.employeeId))];
      console.log("👥 Unique Employee IDs:", employeeIds);

      let employeeMap = {};

      // 3️⃣ Fetch employee details for each employeeId
      for (let id of employeeIds) {
        try {
          const empRes = await axios.get(
            `https://payyug.in/api/hr-employees-filter?employeeId=${id}&superAdminId=${superAdminId}`
          );

          console.log(`📥 Employee Response for ${id}:`, empRes.data);

          if (empRes.data?.data) {
            employeeMap[id] = empRes.data.data.fullName; // correct field
          } else {
            employeeMap[id] = "Unknown";
          }
        } catch (err) {
          employeeMap[id] = "Unknown";
        }
      }

      console.log("📌 Employee Name Map:", employeeMap);

      // 4️⃣ Merge employeeName into the leave list
      const combined = leaves.map((leave) => ({
        ...leave,
        employeeName: employeeMap[leave.employeeId] || "Unknown",
      }));

      console.log("📦 Final Combined Leaves:", combined);

      setLeaveData(combined);

      // 5️⃣ Store first employee info
      if (combined.length > 0) {
        setEmployeeId(combined[0].employeeId);
        setEmployeeName(combined[0].employeeName);
      }
    } catch (error) {
      console.error("❌ Error:", error);
      toast.error("Failed to load leave report.");
    } finally {
      setLoading(false);
    }
  };

  const openRemarkModal = (leave, status) => {
    setSelectedLeave(leave);
    setSelectedStatus(status);
    setAdminRemark("");
    setModalOpen(true);
  };

  const submitStatusUpdate = async () => {
    if (!adminRemark.trim()) {
      return toast.error("Admin remark is required!");
    }

    try {
      await axios.put(
        `https://payyug.in/api/update-status/${selectedLeave.id}`,
        {
          status: selectedStatus,
          adminId: superAdminId,
          adminRemark:adminRemark
          // adminRemark,
        }
      );

      toast.success(`Leave ${selectedStatus} successfully`);
      setModalOpen(false);
      fetchLeaves();
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to update leave");
    }
  };

  // Search filter
  const filtered = leaveData.filter((l) =>
    l.employeeId?.toString().toLowerCase().includes(search.toLowerCase())
  );

  // Pagination
  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;
  const paginatedData = filtered.slice(firstIndex, lastIndex);

  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  const goToPage = (num) => {
    if (num >= 1 && num <= totalPages) setCurrentPage(num);
  };

  return (
    <div className="leave-report-container">
      <Toaster position="top-right" />

      <h2 className="leave-report-title">Employee Leave Report</h2>

      {/* Search */}
      {/* <div className="leave-search-wrapper">
        <input
          type="text"
          placeholder="🔍 Search by Employee ID"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="leave-search"
        />
      </div> */}

      <div className="leave-table-card">
        <table className="leave-report-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Employee Name</th>
              <th>Type</th>
              <th>Start</th>
              <th>End</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="loading">
                  Loading leave records...
                </td>
              </tr>
            ) : paginatedData.length === 0 ? (
              <tr>
                <td colSpan="8" className="no-data">
                  No leave applications found
                </td>
              </tr>
            ) : (
              paginatedData.map((leave, index) => (
                <tr key={leave.id}>
                  {/* SERIAL NUMBER */}
                  <td>{firstIndex + index + 1}</td>

                  <td>{leave.employeeName||"N/A"}</td>
                  <td>{leave.leaveType||"N/A"}</td>
                  <td>{leave.startDate||"N/A"}</td>
                  <td>{leave.endDate||"N/A"}</td>
                  <td>{leave.reason||"N/A"}</td>

                  <td>
                    <span className={`leave-status-badge ${leave.status}`}>
                      {leave.status}
                    </span>
                  </td>

                  <td>
                    <div className="action-buttons">
                      <button
                        className="approve-btn"
                        onClick={() => openRemarkModal(leave, "approved")}
                        disabled={leave.status==="approved"}
                      >
                        Approve
                      </button>

                      <button
                        className="reject-btn"
                        onClick={() => openRemarkModal(leave, "rejected")}
                        disabled={leave.status==="rejected"}
                      >
                        Reject
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="custom-pagination-wrapper">
  {paginatedData.length > 0 && (
    <div className="custom-pagination-container">
      <button
        className="custom-pagination-btn nav-btn"
        onClick={() => goToPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Prev
      </button>

      <span className="CustomerReport-pageIndicator">
            Page {currentPage} of {totalPages}
          </span>

      {/* {[...Array(totalPages)].map((_, i) => (
        <button
          key={i}
          className={`custom-pagination-btn page-btn ${
            currentPage === i + 1 ? "custom-active-page" : ""
          }`}
          onClick={() => goToPage(i + 1)}
        >
          {i + 1}
        </button>
      ))} */}

      <button
        className="custom-pagination-btn nav-btn"
        disabled={currentPage === totalPages}
        onClick={() => goToPage(currentPage + 1)}
      >
        Next
      </button>
    </div>
  )}
</div>

      {/* Modal */}
      {modalOpen && (
        <div className="remark-modal-overlay">
          <div className="remark-modal">
            <h3>
              {selectedStatus === "approved" ? "Approve Leave" : "Reject Leave"}
            </h3>

            <textarea
              placeholder="Enter admin remark"
              value={adminRemark}
              onChange={(e) => setAdminRemark(e.target.value)}
            ></textarea>

            <div className="modal-buttons">
              <button className="modal-submit" onClick={submitStatusUpdate}>
                Submit
              </button>
              <button
                className="modal-cancel"
                onClick={() => setModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaveReport;
